import { ADORNMENTS } from "@/lib/adornments";

// Curated planet/finger adornment guide — parchment styled, reused on the
// reveal screen and inside the take-home keepsake.
export default function AdornmentsSection() {
  return (
    <>
      <h2 className="mb-1 mt-10 font-display text-3xl text-parch-ink">Adornments</h2>
      <p className="mb-4 text-sm text-parch-inkSoft">
        Each finger keeps company with a planet. An invitation to carry an energy — never a prescription.
      </p>
      <div className="space-y-3">
        {ADORNMENTS.map((a) => (
          <div
            key={a.finger}
            data-testid={`adornment-${a.finger.split(" ")[0].toLowerCase()}`}
            className="rounded-xl border border-parch-line bg-parch-card p-5"
            style={{ borderLeftWidth: 5, borderLeftColor: a.color }}
          >
            <div className="flex items-baseline justify-between gap-3">
              <p className="font-display text-xl" style={{ color: a.color }}>{a.finger}</p>
              <span className="font-mono text-[10px] uppercase tracking-wide text-parch-inkSoft">{a.planet}</span>
            </div>
            <p className="mt-0.5 text-sm font-semibold text-parch-inkSoft">{a.energy}</p>
            <p className="mt-2 leading-relaxed text-parch-ink">{a.note}</p>
            <div className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-sm text-parch-ink">
              <span><span className="text-parch-inkSoft">Stone · </span>{a.stones}</span>
              <span><span className="text-parch-inkSoft">Metal · </span>{a.metal}</span>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
